import { UnitOfMeasureEnum } from '../../enums/recipe-enums';

const htmlHead = `
  <head>
    <link rel="preconnect" href="https://fonts.gstatic.com" />
    <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;500&display=swap" rel="stylesheet" />
    <style>
      
      body {
        margin: 0 auto;
      }
      
      #printed-recipe {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        padding: 0px;
        width: 670px; /* width: 7in; */
        height: 900px; /* or height: 9.5in; */
        clear: both;
        page-break-after: always;
        font-family: "Roboto", Arial, Helvetica, sans-serif;
        font-size: 10pt;
      }
      
      #printed-recipe .recipe-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
      
      /* Header */
      #printed-recipe header {
        height: 85px;
        text-align: right;
      }
      
      #printed-recipe header svg {
        float: left;
        width: 150px;
      }
      
      #printed-recipe header p {
        padding-top: 30px;
      }
      
      #traeger-logo {
        height: 85px;
        width: 85px;
      }
      
      #printed-recipe h1 {
        text-align: center;
        font-family: "Roboto", Arial, Helvetica, sans-serif;
        margin-bottom: 0px;
        font-weight: bold;
      }
      
      #printed-recipe h2 {
        font-family: "Roboto", Arial, Helvetica, sans-serif;
        font-weight: bold;
      }
      
      #printed-recipe h3 {
        font-family: "Roboto", Arial, Helvetica, sans-serif;
        font-weight: bold;
        margin-top: 10px;
      }
      
      #printed-recipe .recipe-details {
        margin-top: 40px;
        height: 20px;
      }
      
      #printed-recipe .recipe-details div {
        width: 33%;
        height: 20px;
        float: left;
        text-align: center;
      }
      
      #printed-recipe .title-section h2 {
        text-align: center;
      }
      
      #printed-recipe .recipe-body {
        margin-top: 20px;
      }
      
      #printed-recipe .recipe-body .recipe-ingredients {
        width: 37%;
        float: left;
      }
      
      #printed-recipe .recipe-body .recipe-ingredients .ingredient-group {
        margin-top: 12px;
        margin-bottom: 8px;
        font-family: "Roboto", Arial, Helvetica, sans-serif;
        font-size: 12pt;
        text-transform: capitalize;
        align-self: flex-start;
      }
      
      #printed-recipe .recipe-body .recipe-ingredients ul,
      #printed-recipe .recipe-body .recipe-ingredients ul li {
        margin: 0px;
        list-style: none;
        list-style-type: none;
        padding: 0px;
      }
      
      #printed-recipe .recipe-body .recipe-ingredients ul li {
        margin-bottom: 15px;
        text-transform: capitalize;
      }
      
      #printed-recipe .recipe-body .recipe-instructions {
        width: 60%;
        float: right;
      }
      
      #printed-recipe .recipe-body .recipe-instructions ol {
        padding-left: 20px;
      }
      
      #printed-recipe .recipe-body .recipe-instructions ol li {
        margin-bottom: 15px;
      }
    </style>
  </head>
`;

const buildSteps = (steps) => {
  const stepsArr = [];
  steps.forEach((step) => {
    stepsArr.push(`<li>${step.instruction}</li>`);
  });
  const list = stepsArr.join('');
  return `
  <div class="recipe-instructions">
          <h2>Steps</h2>
          <ol>
            ${list}
          </ol>
        </div>
      </div>
      `;
};

const buildTime = (time) => {
  return time.map(
    ({ value, label }) => `${label ? `</strong>${value}&nbsp${label}</strong>` : ''}`,
  );
};

const buildIngredients = (ingredientSummary, unitOfMeasure) => {
  const groups = ingredientSummary.groups.map(
    (group) => `
    ${group.groupName ? `<h4 class="ingredient-group">${group.groupName}</h4>` : ''}
    <ul>${group.ingredients
      .map(
        (ingredient) => `
      <li>
      ${
        (unitOfMeasure === UnitOfMeasureEnum.Imperial
          ? ingredient.imperial?.measurementDisplay
          : ingredient.metric?.measurementDisplay) || ''
      }
      ${
        (unitOfMeasure === UnitOfMeasureEnum.Imperial
          ? ingredient.unitOfMeasure
          : ingredient.metric?.metricUnitOfMeasure) || ''
      }
      ${ingredient.ingredient?.name || ''}</li>
    `,
      )
      .join('')}</ul>
  `,
  );

  return `
  <div class="recipe-ingredients">
          <h2>Ingredients</h2>
          <ul>
            ${groups.join('')}
          </ul>
        </div>
  `;
};

const buildBody = (
  recipeMetaSection,
  ingredientSummary,
  steps,
  prepTime,
  authorName,
  cookTime,
  servingSize,
  unitOfMeasure,
) => {
  return `
   <body>
     <div id="printed-recipe">
      <div id="recipe-wrapper">
      <header id="print-header">
     <svg xmlns="http://www.w3.org/2000/svg"
        width="50" 
        height="50" 
        fill="currentColor" 
        data-testid="traeger-logo" 
        viewBox="0 0 84 32">
        className={classname}
        <path d="M22.5 30.793s-.055-.028-.43-.111c-.07-.014-.167-.056-.209-.139-.014-.014-.014-.042-.028-.056-.208-.416-.416-.847-.639-1.25-.889-1.625-1.875-2.987-2.195-3.431-.028-.028-.014-.07.028-.084.43-.208.82-.444 1.167-.694a3.86 3.86 0 0 0 1-1.07c.25-.417.39-.89.39-1.417a2.53 2.53 0 0 0-.334-1.265 2.79 2.79 0 0 0-.931-.958c-.584-.39-1.417-.584-2.473-.584h-5.57a.16.16 0 0 0-.168.167v.375c0 .25.056.375.209.403.097.014.236.056.653.111a.192.192 0 0 1 .153.18v9.531a.18.18 0 0 1-.153.18c-.403.07-.542.098-.653.112-.153.028-.209.139-.209.403v.375c0 .097.07.167.167.167h3.334a.169.169 0 0 0 .167-.167v-.361c0-.209-.042-.361-.18-.403 0 0-.126-.028-.681-.125-.084-.014-.14-.083-.153-.167v-3.793c0-.041.028-.083.07-.097.402-.07 2.264-.403 2.264-.403.208-.055.222-.014.333.153.112.167.75 1.056 1.334 2.042.89 1.473 1.111 2 1.111 2.14 0 .055-.069.097-.139.111-.402.07-.472.097-.57.111-.152.028-.207.14-.207.403v.375c0 .084.069.153.152.167h3.418a.169.169 0 0 0 .167-.167v-.375c-.014-.194-.056-.361-.195-.389Zm-5.849-5.515c-.305.07-.889.166-1.764.305-.056.014-.111-.027-.111-.097v-4.557a.15.15 0 0 1 .139-.11h1.528c2.195 0 3.306.583 3.306 1.889 0 .527-.18.958-.5 1.32-.444.486-1.222.972-2.598 1.25Zm66.519 5.515s-.056-.028-.432-.111c-.069-.014-.166-.056-.208-.139-.014-.014-.014-.042-.028-.056-.208-.416-.416-.847-.639-1.25-.889-1.625-1.875-2.987-2.195-3.431-.028-.028-.014-.07.028-.084a7.85 7.85 0 0 0 1.167-.694 3.862 3.862 0 0 0 1-1.07c.25-.417.39-.89.39-1.417 0-.445-.112-.875-.334-1.265a2.791 2.791 0 0 0-.931-.958c-.584-.39-1.417-.584-2.473-.584h-5.57a.16.16 0 0 0-.168.167v.375c0 .25.056.375.209.403.097.014.236.056.653.111a.192.192 0 0 1 .153.18v9.531a.18.18 0 0 1-.153.18c-.403.07-.542.098-.653.112-.153.028-.209.139-.209.403v.375c0 .097.07.167.167.167h3.334a.169.169 0 0 0 .167-.167v-.361c0-.209-.042-.361-.18-.403 0 0-.126-.028-.681-.125-.084-.014-.14-.083-.153-.167v-3.793c0-.041.028-.083.07-.097.402-.07 2.264-.403 2.264-.403.208-.055.222-.014.333.153.111.167.75 1.056 1.334 2.042.89 1.473 1.111 2 1.111 2.14 0 .055-.07.097-.139.111-.402.07-.472.097-.57.111-.152.028-.208.14-.208.403v.375c0 .084.07.153.153.167h3.376a.169.169 0 0 0 .167-.167v-.375c.014-.194-.028-.361-.153-.389Zm-5.85-5.515c-.305.07-.889.166-1.764.305-.056.014-.111-.027-.111-.097v-4.557a.15.15 0 0 1 .139-.11h1.528c2.195 0 3.306.583 3.306 1.889 0 .527-.18.958-.5 1.32-.444.486-1.222.972-2.598 1.25Zm-17.227.318h-4.25a.169.169 0 0 0-.167.166v.375c0 .209.041.361.18.403.14.042 1.376.209 1.542.25.18.028.209.167.209.25v2.362s-.014.445-.612.917c-.264.208-.625.361-1.083.486-.445.111-.89.167-1.306.167a4.81 4.81 0 0 1-1.931-.403 4.405 4.405 0 0 1-1.57-1.125c-.834-.931-1.25-2.084-1.25-3.46 0-.68.11-1.361.333-2.014a5.327 5.327 0 0 1 .917-1.764 4.36 4.36 0 0 1 1.473-1.237 4.101 4.101 0 0 1 1.944-.458c.862 0 1.64.208 2.279.611l.028.014c.403.25.82.736 1.042 1.278.083.222.097.361.11.5.029.153.14.209.404.209h.375a.16.16 0 0 0 .166-.167v-3.237a.16.16 0 0 0-.166-.167h-.375c-.25 0-.306.028-.348.18-.027.168-.07.306-.139.39-.013.014-.041.028-.055.041a.153.153 0 0 1-.111 0 6.796 6.796 0 0 0-1.362-.444 8.945 8.945 0 0 0-1.834-.209 6.638 6.638 0 0 0-3.292.848 6.345 6.345 0 0 0-2.376 2.32 6.48 6.48 0 0 0-.861 3.265c0 .861.166 1.709.5 2.5a5.53 5.53 0 0 0 1.459 2.029 6.07 6.07 0 0 0 1.361.861c.5.223 1.028.403 1.556.5a8.201 8.201 0 0 0 1.64.167c1.014 0 2.097-.222 3.209-.653 1.125-.472 1.667-.889 1.667-1.32V26.93c0-.07 0-.139.07-.18.083-.042.527-.181.527-.181.111-.056.236-.139.25-.403v-.375c.014-.111-.055-.194-.153-.194ZM10.607 21.79l-.306-1.89c0-.013-.014-.027-.014-.027a.255.255 0 0 0-.097-.139c-.014-.014-.055-.014-.055-.014H.493c-.097 0-.167.097-.167.167l-.32 1.917c-.027.111.029.208.181.208h.376c.347 0 .486 0 .555-.18 0 0 .153-.39.292-.611a.844.844 0 0 1 .195-.237c.236-.18.472-.222 1.055-.222h1.723a.14.14 0 0 1 .139.139v9.586c0 .139-.139.18-.153.18l-.653.112c-.153.027-.208.139-.208.403v.375c0 .083.07.18.208.18h3.251c.111 0 .209-.097.209-.18v-.375c0-.25-.056-.375-.209-.403-.097-.014-.25-.056-.653-.111a.176.176 0 0 1-.153-.181v-9.586a.14.14 0 0 1 .14-.139h1.68c.584 0 .82.056 1.056.222.07.056.125.14.195.236.139.223.291.612.291.612.07.18.209.18.556.18h.375c.125-.014.18-.152.153-.222Zm60.281 7.503h-.375c-.347 0-.486 0-.556.18 0 0-.222.542-.375.764a.845.845 0 0 1-.194.237c-.139.11-.403.222-.834.222h-4.07a.184.184 0 0 1-.18-.18v-4.252c0-.097.082-.18.18-.18h3.584c.042 0 .083.013.097.055 0 0 .14.333.14.347.055.14.138.209.402.209h.389c.14 0 .18-.07.18-.209v-1.848c0-.11-.04-.208-.18-.208h-.389c-.25 0-.333.07-.403.209-.014.013-.139.333-.153.333a.25.25 0 0 1-.097.07h-3.57a.19.19 0 0 1-.195-.195v-3.918c0-.097.084-.18.18-.18h3.363c.583 0 .736.027.972.208.07.055.125.139.195.236.139.222.292.611.292.611.07.181.208.181.555.181h.375c.153 0 .209-.139.181-.208l-.32-1.918a.255.255 0 0 0-.097-.139c-.014-.013-.055-.013-.055-.013h-8.114c-.097 0-.166.097-.166.166v.375c0 .209.041.362.18.403l.625.111c.167.028.209.07.209.181v9.531a.163.163 0 0 1-.14.166c-.402.07-.569.111-.666.125-.167.028-.222.167-.222.417v.361c0 .111.11.18.208.18h8.766c.07 0 .14-.096.14-.152l.319-2.07c.028-.083-.028-.208-.18-.208Zm-24.048-.001h-.375c-.347 0-.486 0-.555.181 0 0-.223.542-.375.764a.84.84 0 0 1-.195.236c-.139.111-.403.223-.834.223h-4.084a.184.184 0 0 1-.18-.181v-4.251c0-.098.083-.18.18-.18h3.584c.042 0 .084.013.098.055 0 0 .139.333.139.347.055.139.138.209.402.209h.389c.14 0 .181-.07.181-.209v-1.848c0-.11-.042-.208-.18-.208h-.39c-.25 0-.333.07-.403.208-.013.014-.138.334-.152.334-.028.027-.056.055-.098.07h-3.57a.19.19 0 0 1-.194-.195v-3.918c0-.097.083-.18.18-.18h3.376c.584 0 .736.027.973.208.069.055.125.139.194.236.139.222.292.611.292.611.07.18.208.18.555.18h.376c.152 0 .208-.138.18-.208l-.32-1.917a.255.255 0 0 0-.097-.139c-.014-.014-.055-.014-.055-.014h-8.113c-.098 0-.167.098-.167.167v.375c0 .209.042.361.18.403 0 0 .07.014.626.111.055.014.125.028.166.07l.014.014a.19.19 0 0 1 .028.083v9.53a.163.163 0 0 1-.139.167c-.403.07-.57.111-.667.125-.166.028-.222.167-.222.417v.361c0 .111.111.18.208.18h8.767c.07 0 .139-.096.139-.152l.32-2.07c.027-.07-.029-.195-.182-.195Zm-10.823 1.473c-.069-.014-.083-.014-.222-.042l-.291-.055c-.014 0-.07 0-.098-.056-.027-.028-.514-1.334-.528-1.39-1.403-3.681-1.611-4.112-4.195-9.446-.111-.209-.306-.334-.5-.334a.556.556 0 0 0-.5.334c-.056.097-2.96 6.835-4.071 9.433l-.445 1.014-.097.208s-.042.098-.07.125a.298.298 0 0 1-.097.056c-.402.07-.57.097-.653.111-.152.028-.208.139-.208.403v.375c0 .083.07.18.208.18h3.251c.111 0 .209-.097.209-.18v-.375c0-.25-.056-.375-.209-.403-.097-.014-.389-.083-.792-.153-.027-.014-.041-.014-.055-.028-.097-.041-.14-.139-.111-.208 0 0 .291-.806.416-1.098.153-.375.334-.777.445-1.097.07-.167.111-.306.167-.417a.285.285 0 0 1 .264-.18h4.362c.097 0 .264-.014.306.138.014.056.403 1.056.639 1.779.055.18.125.444.18.653.014.07.056.194.07.25.041.125.028.208-.042.264-.014.014-.028.014-.028.014-.403.07-.444.07-.541.097-.153.028-.209.139-.209.403v.375c0 .083.07.18.209.18h3.25c.167 0 .209-.097.209-.18v-.375c-.028-.223-.084-.334-.223-.375Zm-4.167-4.21h-3.682c-.07 0-.139-.07-.097-.153l1.806-4.418c1.056 2.196 1.625 3.376 2.056 4.39.014.028.014.042.014.042.028.056-.014.14-.097.14Zm-1.432-23.38 4.446 2.542c.014.014.027.014.041 0 .25-.167 2.945-2.181 7.016-4.932 0 0 .556-.361 1.042-.014l7.294 5.099c.028.028.07.028.11.014l4.544-1.904a.637.637 0 0 1 .57.056c1.027.64 5.029 3.181 5.473 3.445.306.181.097.487-.167.348-.472-.25-4.987-2.64-5.265-2.779-.292-.139-.347-.153-.68 0 0 0-2.78 1.306-3.071 1.445-.292.139-.125.472.347.264.473-.208 2.39-.973 2.751-1.125.361-.153.653.027.417.375-.25.347-.556.764-.806 1.097-.25.348.07.403.542.375.472-.027.417.459-.097.584-.528.125-.653.167-.653.514s.778.82 1.764 1.222c.986.403 6.89 2.848 6.89 2.848.529.181.306.64-.055.528-.333-.097-7.905-2.584-9.169-3.403-1.264-.82-3.918-2.737-10.947-7.336 0 0-.348-.222-.681-.027L36.1 6.287s-1.25.861-1.542 1.055c-.236.167-.028.528.68.098l6.42-3.751s.666-.362.569.333c0 0-.195 1.667-.25 2.112-.056.444-.25 1.278.486 1.236 0 0 .917-.097.444.64-.027.041-4.042 5.71-4.167 5.806-.236.181-.57.042-.487-.416 0 0 .737-2.89.75-2.973.098-.445-.25-.612-.597-.264-.361.347-2.834 2.723-3.126 3-.291.292-.653.028-.486-.305.167-.347 1.598-3.057 1.778-3.418.195-.36-.18-.625-.528-.291-.347.333-3.556 3.14-3.556 3.14-1.236 1.013-4.46.763-9.03 3.792-.653.403-.862-.167-.514-.458a53.086 53.086 0 0 0 1.611-1.404c.264-.25.223-.666-.458-.5a967.27 967.27 0 0 1-4.515 1.056s-1.529.417-1.64.056c-.083-.292.445-.473.445-.473s7.474-2.223 15.365-7.794c.028-.013.014-.055 0-.055l-3.167-1.945a.568.568 0 0 0-.528 0s-3.987 2.209-4.238 2.334c-.236.139-.097.403.376.18.319-.166 2.209-1.097 2.778-1.375.64-.32 1.18-.097.82.403-.334.43-2.237 2.987-2.515 3.348-.264.347-.861.347-.639-.32.222-.666.111-.388.18-.61.07-.223-.097-.431-.374-.112a914.09 914.09 0 0 0-1.71 1.876c-.485.528-.68.222-.583-.056.125-.333.167-.417.223-.583.069-.237-.167-.306-.292-.14-.14.167-1.917 2.335-2.167 2.668-.25.334-.681.167-.264-.639.444-.847-1.25-.361-1.793-.236-.541.111-7.307 2.223-8.46 2.459-.403.125-.57-.306-.111-.5.458-.18 2.5-.89 2.848-1.014.347-.125.264-.348-.153-.306-.32.042-5.057.403-5.863.458-.333.028-.417-.333.042-.389.611-.069 7.53-1.153 10.6-2.82 2.473-1.333 11.197-6.057 11.197-6.057s.264-.083.459.042Zm40.789 8.474c-.111-.055-.903-.472-1.278-1.083 0 0 .528.25.889.347.417.125.57-.375.264-.486-.222-.084-1.181-.626-1.237-1.015 0 0 .528.417.848.459.222.028.403-.306.07-.459-.195-.097-.779-.458-.931-.847 0 0 .458.208.61.18.21-.027.279-.36-.055-.472a1.056 1.056 0 0 1-.583-.472c-.014-.014-.028-.07-.028-.097 0 0 .083.07.375.18.292.098.306-.264.139-.375-.167-.111-.653-.403-.736-.528.014 0 .555.334.639.153.083-.18-.153-.306-.334-.417-.25-.166-.375-.458-.347-.458.07.028.417.292.486.055.014-.083-.028-.139-.097-.18-.167-.084-.25-.18-.361-.43-.111-.25-.07-.543-.223-.723-.055-.056-.236-.084-.291.166-.056.25-.07.5-.25.653-.18.153-.459.264-.348.459.07.111.32-.014.417-.084.014-.013.014.181-.139.306-.153.153-.556.25-.57.459-.013.208.292.18.64.027-.056.195-.612.5-.75.556-.278.139-.084.43.124.403.209-.028.528-.222.542-.222.028.014-.027.097-.041.097-.07.097-.167.18-.25.264-.111.111-.237.25-.403.306a.51.51 0 0 0-.237.138c-.027.056-.041.112-.027.167a.29.29 0 0 0 .236.195c.153.027.306-.028.445-.084.069-.027.18-.125.263-.139a1.242 1.242 0 0 1-.277.473 1.68 1.68 0 0 1-.556.389c-.111.055-.222.125-.264.25-.014.028-.014.07-.014.111.014.07.07.111.125.153a.589.589 0 0 0 .347.028c.056-.014.64-.209.626-.278.013.07-.084.166-.112.208a3.17 3.17 0 0 1-.305.306c-.125.11-.264.208-.403.305-.139.098-.292.14-.43.223a.336.336 0 0 0-.14.166.222.222 0 0 0 .028.209c.028.027.07.055.111.055.25.07.611-.097.834-.208.055-.028.32-.18.32-.18-.028.069-.167.416-.765.624-.208.07-.43.126-.625.209a.36.36 0 0 0-.153.097.179.179 0 0 0-.055.167c.014.07.07.111.125.139a.72.72 0 0 0 .25.042c.611 0 1.278-.348 1.278-.348a.52.52 0 0 0-.097.083 2.943 2.943 0 0 1-.737.487c-.18.083-.403.097-.555.208-.098.056-.14.195-.07.292.084.139.292.139.43.111.14-.014.279-.07.418-.111.208-.07.416-.139.625-.222l-.014.014c-.097.097-.18.194-.278.291a1.945 1.945 0 0 1-.445.306c-.139.07-.097.25.028.306.07.041.167.041.25.027.25-.041.473-.18.681-.305.014-.014.111-.056.111-.07.042.542-.153 1.431-.25 1.417a9.337 9.337 0 0 1-.556-.166 31.88 31.88 0 0 1-2.403-.89c-.333-.11-.542.39-.139.528-.014-.014 1 .362 2.5.806.848.25 2.418.653 2.487.667.348.07.445-.236.14-.334-.028-.013-.473-.138-1-.291-.07-.014-.181-.459-.167-1.681 0 .028.097.097.11.097.098.07.181.139.292.208.167.098.39.195.57.098.097-.056.18-.209.07-.292-.112-.097-.695-.333-.848-.82-.014-.014.5.473 1.14.584.29.07.416-.264.222-.43-.181-.168-1.029-.529-1.223-1.057.014 0 .542.39 1.07.459.07.014.208.027.278-.098.097-.125.097-.291-.056-.36Zm-4.14-2.32c-.153-.222-1.64-.778-1.806-1.32.014 0 .403.32 1.195.528.61.167.722-.458.333-.583-1.153-.375-1.64-1.39-1.653-1.417 0 0 .82.639 1.236.694.223.028.39.028.5-.097.25-.403-.333-.556-.736-.792-.639-.375-1.056-.986-1.097-1.125.055.014.916.611 1.403.486a.276.276 0 0 0 .097-.486c-.139-.083-.764-.347-1.153-.75-.403-.403-.486-.57-.486-.598.041-.014.57.278.875.334.305.055.514-.334.208-.487-.194-.069-1.083-.583-1.153-.847.486.208 1.056.361 1.042.014-.014-.264-.611-.417-.82-.611-.208-.181-.32-.431-.305-.417.139.097.542.25.667.083.18-.25-.209-.389-.445-.583-.236-.195-.333-.792-.417-1.126-.097-.333-.36-.236-.375-.125-.014.014-.055.75-.222 1.084-.167.333-.459.5-.695.611-.11.056-.166.125-.152.236.027.209.305.14.444.098.139-.056.18-.07.306-.14.097-.04-.167.445-.528.612-.25.111-.5.236-.417.486.097.264.806-.027.82-.027-.125.166-.917.666-1.153.82-.209.096-.167.5.32.402.346-.055.735-.292.735-.292.14-.055-.555.653-1.305 1.042-.209.125-.181.264-.153.348.055.125.208.194.416.139.306-.084.917-.348 1.042-.445-.041.264-1.347 1.097-1.611 1.25-.167.111-.209.264-.14.39.056.124.251.208.64.013.097-.041.89-.444.89-.444-.126.264-.89.972-1.807 1.583-.111.098-.18.223-.139.348.056.166.18.25.5.139.292-.084 1.126-.528 1.126-.528-.542.805-1.57 1.514-1.723 1.611-.18.14-.222.306-.111.459.097.153.305.139.416.125.75-.097 1.584-.848 1.598-.848-.097.223-.486.848-1.598 1.487-.222.139-.166.333-.11.403.069.11.222.11.305.11.834-.069 1.445-.541 1.431-.513-.125.375-.736.847-.903 1-.167.153-.014.5.5.417.347-.028.89-.542.89-.542s-.029 1.334-.029 1.487c0 .236-.027.653-.083.916-.056.25-.417.584-.417.584-.25.194.028.208.292.111.458-.139.653.209.973.195.402.027.125-.223.388-.181.417.18.64.194.931.07.417-.167-.917-.014-.958-1.084-.014-.18-.07-1.153-.084-1.82.098.111.292.32.612.43.444.14.666.07.722-.069a.335.335 0 0 0-.167-.389c-.305-.167-.57-.347-.791-.903-.014-.07.18.195.889.514.708.32.736-.111.736-.167-.014-.222-.403-.263-.695-.486-.486-.347-.486-.5-.486-.5s.736.417 1.056.278c.18-.083.25-.347-.139-.5-.333-.125-.93-.445-1.014-.64.458.154 1.042.431 1.347.417.306 0 .362-.222.195-.472Z"/>
        </svg>
        <p>Download Traeger App for free recipes</p>
      </header>
      <div class="title-section">
        <h1>${recipeMetaSection.title}</h1>
        <h2>${authorName}</h2>
      </div>
      <div class="recipe-details">
        <div><strong>Prep Time:</strong> ${buildTime(prepTime)}</div>
        <div><strong>Cook Time:</strong> ${buildTime(cookTime)}</div>
        <div><strong>Serves:</strong> ${servingSize} people</div>
      </div>
      <div class="recipe-body">
        ${buildIngredients(ingredientSummary, unitOfMeasure)}
        ${buildSteps(steps)}
      </div>
      </div>
    </div>
  </body>
  `;
};

const buildRecipeToPrint = (props) => {
  const {
    recipeMetaSection,
    ingredientSummary,
    steps,
    prepTime,
    authorName,
    cookTime,
    servingSize,
    unitOfMeasure,
  } = props;

  return `
    <!DOCTYPE html>
        <html>
        ${htmlHead}
        ${buildBody(
          recipeMetaSection,
          ingredientSummary,
          steps,
          prepTime,
          authorName,
          cookTime,
          servingSize,
          unitOfMeasure,
        )}
        </html>
  `;
};
export default buildRecipeToPrint;
